export default __webpack_public_path__ + "static/media/11.1.50c44824.jpg";